export default "__VITE_ASSET__nUM1AP5W__"